import DataTableComponent, {defaultColumns, actionColumn} from '../components/DataTableComponent';
import template from '../helpers/template';
import i18n from '../i18n.js';

export default {
    when: "dashboard",

    mounted() {
        $('.js-datatable').each(function () {
            const $this = $(this)
            $this.data('instance', new DataTableComponent(this, {
                ...$this.data(),
                tableOptions: {
                    select: false,
                    stateSave: false,
                    paging: false,
                    info: false,
                    ordering: true,
                    order: [
                        [9, 'asc']
                    ],
                    columns: [
                        ...defaultColumns,
                        {
                            data: 'status',
                            render(data, type, row, meta) {
                                const status = data ?? 1;
                                return `<span class="status-pill status-${status}">${i18n.t(`places.status.${status}`)}</span>`
                            }
                          ,
                            name: 'status',
                            orderable: true,
                        },
                        ...actionColumn
                    ],
                },
            }));
        });
    },
}
